<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="BusinessApplyform"
          status-icon
          :model="BusinessApplyform"
          :rules="rules"
          label-width="120px"
          class="BusinessApplyInfo"
          style="width: 90%;"
          v-loading="loading"
          :element-loading-text="loadingText"
        >
          <el-row>
            <el-col>
              <el-form-item
                label="商户编号"
                prop="BusinessName"
              >
                <el-input
                  v-model="BusinessApplyform.SubMerId"
                  :disabled="false"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item
                label="收款户名"
                prop="AccountName"
              >
                <el-input
                  v-model="BusinessApplyform.AccountName"
                  :disabled="false"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item
                label="收款账号"
                prop="Account"
              >
                <el-input
                  v-model="BusinessApplyform.SubMerchantAccNo"
                  :disabled="false"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item
                label="收款银行"
                prop="RecBankNo"
              >
                <el-select
                  filterable
                  placeholder="请选择"
                  v-model="BusinessApplyform.RecBankNo"
                  :disabled="false"
                >
                  <el-option
                    v-for="item in Banks"
                    :key="item.BankNo"
                    :label="item.BankName"
                    :value="item.BankNo"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item
                label="商户余额"
                prop="Apply"
              >
                <el-input
                  v-model="BusinessApplyform.Apply"
                  :disabled="false"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col v-if="IsOutPay==true">
              <el-form-item
                label="提现金额"
                prop="TrxAmount"
              >
                <el-input-number
                  :precision="2"
                  :step="1"
                  :min="0"
                  v-model="BusinessApplyform.TrxAmount"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col v-if="IsOutPay==true">
              <el-form-item
                label="附言"
                prop="Remark"
              >
                <el-input v-model="BusinessApplyform.Remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center;">
        <el-button
          v-if="IsOutPay==true"
          @click="OutMonty"
        >提现</el-button>
        <el-button @click="OnCancel">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>


<script>
import WebApis from "../../../apis";
import utils from "../../../../../../utils";

export default {
  name: "BusinessApplyInfoPage",
  data() {
    return {
      BusinessApplyform: {
        SubMerId: "",
        AccountName: "",
        SubMerchantAccNo: "",
        RecBankNo: "",
        Apply: "",
        TrxAmount: "",
        Remark: "",
      },
      resData: "",
      BusinessInfo: "",
      Banks: [],
    };
  },
  props: {
    BusinessCode: {  //商户编号
      type: String,
      default: "",
    },
    AccountName: {  //收款户名
      type: String,
      default: "",
    },
    SubMerchantAccNo: {  //收款账号
      type: String,
      default: "",
    },
    RecBankNo: {  //收款银行
      type: String,
      default: "",
    },
    IsOutPay: {   //提现金额
      type: Boolean,
      default: true,
    },
  },
  created: function () {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      return utils.waitAll([() => this.GetBanks()]).then(() => {
        this.GetInfo();
      });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
    GetBanks() {
      return new WebApis.BankApi().FindAll().then((res) => {
        console.log(res);
        if (res.data.Data) {
          this.Banks = res.data.Data;
        }
      });
    },
    GetInfo() {
      console.log("商户编号", this.BusinessCode);
      if (this.BusinessCode) {
        this.BusinessApplyform.SubMerId = this.BusinessCode;
        this.BusinessApplyform.AccountName = this.AccountName;
        this.BusinessApplyform.SubMerchantAccNo = this.SubMerchantAccNo;
        this.BusinessApplyform.RecBankNo = this.RecBankNo;

        let BusinessApplySearch = {
          SubMerId: this.BusinessCode,
        };
        console.log("BusinessApplySearch", BusinessApplySearch);
        return new WebApis.BusinessApplyApi()
          .GetItemBySubMerId(BusinessApplySearch)
          .then((res) => {
            console.log("商户余额结果", res);
            if (res.data.Data) {
              this.resData = res.data.Data;
              this.BusinessApplyform.Apply = this.resData.Apply;
            }
          })
          .catch((e) => {
            console.log("商户余额结果异常", e);
            this.$message({
              showClose: true,
              message: e.RspMsg
                ? "获取商户余额信息失败!" + e.RspMsg
                : "获取商户余额信息失败!",
              type: "error",
            });
            return false;
          });
      }
    },
    OutMonty() {
      let OutPaymentRequest = {
        SubMerId: this.BusinessApplyform.SubMerId,
        AccountName: this.BusinessApplyform.AccountName,
        Account: this.BusinessApplyform.SubMerchantAccNo,
        RecBankNo: this.BusinessApplyform.RecBankNo,
        TrxAmount: this.BusinessApplyform.TrxAmount + "",
        DrawingFlag: "0",
      };

      if (
        this.BusinessApplyform.TrxAmount > this.BusinessApplyform.Apply
      ) {
        this.$message({
          showClose: true,
          message: "提现金额不能大于余额",
          type: "error",
        });

        return false;
      }

      return new WebApis.BusinessOutPaymentApi()
        .SubMerAccOutPayment(OutPaymentRequest)
        .then((res) => {
          console.log("商户提现结果", res);

          if (res.RspCode == "1") {
            this.$message({
              showClose: true,
              message: "提现成功!",
              type: "success",
            });
            this.$emit("clickOk", {});
          } else {
            this.$message({
              showClose: true,
              message: res.RspMsg + "," + res.DescExtend,
              type: "error",
            });

            return false;
          }
        })
        .catch((e) => {
          console.log("提现失败", e);
          this.$message({
            showClose: true,
            message: e.RspMsg ? e.RspMsg : "提现失败!",
            type: "error",
          });
          return false;
        });
    },
  },
};
</script>
